// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__3L7fE","header":"Error_header__sBcko","message":"Error_message__16I6L"};